<template>
  <div id="localplan">

      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 1684 1191" style="enable-background:new 0 0 1684 1191;" xml:space="preserve" v-if="chosenLevel == 'PARTER'">
          <g id="Layer_2">

        <image style="overflow:visible;" width="3417" height="2388" xlink:href="../assets/parter.jpg" transform="matrix(0.48 0 0 0.48 16 22.94)">
    </image>
</g>
          <g id="Layer_1">
    <text transform="matrix(1 0 0 1 887.7554 567.8594)"><tspan x="0" y="0" class="st0 st1 st2">M. 4</tspan><tspan x="-6.26" y="14.2" class="st0 st1 st2">2P+AK</tspan></text>
              <g  class="outline"  @click="chooseLocal(1)" :class="{active : (chosenLocal == 1)}">
       <polygon class="st0" points="375.14,599.25 375.14,628.11 364.54,628.11 364.54,932.6 286.21,932.6 286.21,742.37 187.27,742.37
		187.27,553.9 364.54,553.9 364.54,599.25 	"/>
                  <text transform="matrix(1 0 0 1 301.9952 760.8724)" class="st1 st2 st3">LU. 1</text>
    </g>

</g>
</svg>




  </div>
</template>

<script>

    export default {
        name: 'Localplan',
        props:  ['chosenLocal', 'chosenLevel'],
        methods: {
            chooseLocal(number) {
                   // this.$emit('chooseLocal', number);
                window.open('../___lokale___/U' + number + '.pdf')
            },
        }
    }
</script>

